<div class="space-y-6">
   <!-- Filtering Workspace -->
   <div
      class="card-bg rounded-2xl p-6 border border-slate-200 dark:border-white/5 backdrop-blur-xl animate-in slide-in-from-top-4 duration-500 relative z-50 !overflow-visible">
      <h2
         class="text-xl font-bold bg-gradient-to-r from-violet-600 to-indigo-600 dark:from-violet-400 dark:to-indigo-400 bg-clip-text text-transparent mb-6">
         Prompt Release Manager
      </h2>

      <div class="grid grid-cols-12 gap-4 md:gap-6 relative !overflow-visible">
         <div class="col-span-12 md:col-span-6 xl:col-span-3">
            <app-dropdown title="Available Products" [options]="productOptions()" [selectedValue]="String(productId())"
               selectionMode="single" placeholder="All Products" [fullWidth]="true" variant="themeBase" size="lg"
               (selectionChange)="onProductChange($event)" />
         </div>

         <div class="col-span-12 md:col-span-6 xl:col-span-3">
            <app-dropdown title="Features" [options]="featureOptions()" [selectedValue]="String(featureId())"
               selectionMode="single" placeholder="Select feature" [fullWidth]="true" variant="themeBase" size="lg"
               (selectionChange)="onFeatureChange($event)" />
         </div>

         <div class="col-span-12 md:col-span-6 xl:col-span-3">
            <app-dropdown title="Feature Options" [options]="optionOptions()" [selectedValue]="String(optionId())"
               selectionMode="single" placeholder="Select sub-variant" [fullWidth]="true" variant="themeBase" size="lg"
               (selectionChange)="onOptionChange($event)" [disabled]="!featureId()" />
         </div>

         @if (hasCategories()) {
         <div class="col-span-12 md:col-span-6 xl:col-span-3">
            <app-dropdown [title]="'Category *'" [options]="categoryOptions()" [selectedValue]="String(categoryId())"
               selectionMode="single" placeholder="Select category" [fullWidth]="true" variant="themeBase" size="lg"
               (selectionChange)="onCategoryChange($event)" [disabled]="!optionId()" />
         </div>
         }

         <div class="col-span-12 md:col-span-6 xl:col-span-3">
            <!-- Hidden label to maintain vertical alignment with dropdowns -->
            <label class="hidden md:block mb-1.5 text-sm font-medium opacity-0 pointer-events-none select-none">Action</label>
            <div class="flex items-center gap-3 w-full">
               <app-button class="flex-1" variant="primary" (buttonClick)="applyFilters()" [disabled]="!canApply()"
                  className="w-full !h-12 whitespace-nowrap">
                  Apply
               </app-button>
               <app-button class="flex-1" [disabled]="!hasActiveFilters()" variant="secondary" (buttonClick)="clearFilters()"
                  className="w-full !h-12">
                  Clear
               </app-button>
               </div>
         </div>
      </div>
   </div>

   <!-- Main Workspace (Full Width Manifest) -->
   <div class="col-span-12 animate-in fade-in duration-700">
      <div class="card-bg rounded-2xl border border-slate-200 dark:border-white/5 p-6 shadow-sm">
         <!-- Header with Action -->
         <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
            <div class="flex flex-wrap items-center gap-3">
               <h3 class="text-lg md:text-xl font-bold text-slate-800 dark:text-slate-100">Prompt Release Manifest</h3>
               <!-- <span
                  class="text-[0.625rem] px-1.5 py-0.5 md:px-2 md:py-1 bg-slate-100 dark:bg-slate-800/80 rounded font-medium text-slate-400 dark:text-slate-500 uppercase tracking-tight whitespace-nowrap shrink-0">
                  Reverse Chronological
               </span> -->
            </div>
            <app-button variant="primary" (buttonClick)="openAddModal()"
               className="!py-2 md:!py-2.5 !px-4 md:!px-6 text-xs md:text-sm font-semibold flex items-center justify-center gap-2 shadow-lg shadow-purple-500/20 active:scale-95 transition-all w-full md:w-auto whitespace-nowrap">
               <app-icon name="plus" [size]="18" />
               ADD PROMPT
            </app-button>
         </div>

         <!-- Full Width Table -->
         <app-paginated-table [tableData]="prompts()" [headers]="headers" [isCheckboxShow]="false"
            [tableActionOptions]="{ showToggleButton: true, toggleOptions: actionOptions }"
            (actionSelected)="handleAction($event)"
            [tableWrapperClass]="'!h-auto !overflow-x-auto !bg-transparent !backdrop-blur-none !shadow-none !border-none'" 
         />
      </div>
   </div>

   <!-- Notification Alerts -->
   @if (successMessage()) { <app-alert [message]="successMessage()" type="success" [duration]="3000"
      (close)="successMessage.set('')" /> }
</div>